// extracted by mini-css-extract-plugin
export var searchHeader = "_2k-0";
export var searchHeaderDark = "_2k-1";